<div class="sponsors-grid grid grid-cols-[auto_1fr_auto_1fr] items-center gap-x-4 gap-y-2 py-2" data-cy="sponsorsDialogList">
  @for (sponsor of data.sponsors; track sponsor) {
    <div class="manager-logo flex items-center shrink-0">
      <img [src]="sponsor.logoUrl" alt="Investment Manager Logo" data-cy="sponsorsDialogLogo">
    </div>
    <div class="manager-name font-bold text-charcoal-grey" data-cy="sponsorsDialogName">{{ sponsor.name }}</div>
  }
</div>
